import React from 'react'
import './RateLimitDialog.css';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

const RateLimitDialog = function({ isOpen, onClose, message }) {
    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog 
            open={isOpen} 
            className="RateLimitDialog" 
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    handleClose();
                    return;
                }
                handleClose();
            }}
        >
            <DialogTitle>请求限制</DialogTitle>
            <DialogContent>
                <div className="RateLimitContent">
                    <div className="RateLimitMessage">
                        {message || '请求过于频繁，请稍后重试'}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div onClick={handleClose} className="RateLimitBtn">
                    确定
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default RateLimitDialog;
